import handleSave from '@vindr/ui/src/components/Templates/actionSubmit';
import {
  useChangeOrderDevice,
  useGetDeviceStatisticsAll,
  useReceptOrder,
} from '@vindr/services/actions/order.action';
import { Checkbox, Form, Modal } from 'antd';
import { useGlobalContext } from '#contexts/GlobalContext';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DeviceSelect from './DeviceSelect';

const CreateReception = ({
  open,
  action,
  onCancel,
  selectedRowKeys,
  setSelectedRowKeys,
  params,
}) => {
  const { t } = useTranslation('Vindoc');
  const { message } = useGlobalContext();
  const [form] = Form.useForm();
  const defaultInstitution = useMemo(() => selectedRowKeys[0]?.institution_id, [selectedRowKeys]);
  const defaultDevice = useMemo(
    () =>
      selectedRowKeys.reduce(
        (acc, item) => (acc === item.device_id ? acc : null),
        selectedRowKeys[0]?.device_id
      ),
    [selectedRowKeys]
  );

  const deviceStatistics =
    useGetDeviceStatisticsAll({
      // offset: 0,
      // limit: 25,
      modalities: selectedRowKeys.map((it) => it?.procedure?.modality),
      institution_ids: [selectedRowKeys?.[0]?.institution_id],
      scheduled_date_from: params?.scheduled_date_from,
      scheduled_date_to: params?.scheduled_date_to,
    })?.data?.data || [];

  useEffect(() => {
    form.setFieldsValue({
      institution_id: defaultInstitution,
      order_ids: selectedRowKeys.map((item) => item.id),
      device_id: defaultDevice,
    });
  }, [open]);

  const { mutate: receptOrder, isLoading: isReceipting } = useReceptOrder();
  const { mutate: changeOrderDevice, isLoading: isUpdating } = useChangeOrderDevice();

  const actionSave = () => {
    handleSave({
      message,
      form,
      type: action === 'receive' ? 'create' : 'edit',
      mutate: { create: receptOrder, update: changeOrderDevice },
      t,
      onDone: () => {
        onCancel();
        setSelectedRowKeys(() => []);
      },
      createParams: (values) => ({
        ...values,
        institution_id: selectedRowKeys?.[0]?.institution_id,
        order_ids: selectedRowKeys.map((item) => item.id),
      }),
      editParams: (values) => ({ ...values, orders: selectedRowKeys }),
      code: { created: 'SCD_8004', updated: 'SCD_8001' },
    });
  };

  return (
    <Modal
      className="w-[800px] max-w-[80vw]"
      open={open}
      maskClosable={false}
      centered
      onCancel={onCancel}
      destroyOnClose
      forceRender
      title={action === 'receive' ? t('Reception') : t('Select Device')}
      okText={t('Save')}
      confirmLoading={isReceipting || isUpdating}
      onOk={form.submit}
    >
      <Form form={form} onFinish={actionSave} layout="vertical">
        {/* <FormItem.InstitutionList
          name="institution_id"
          label={t('Institution')}
          keyValue="id"
          multiple={false}
          disabled
          required
        /> */}
        <Form.Item name="device_id" className="max-h-[70vh] overflow-y-scroll">
          <DeviceSelect devices={deviceStatistics} />
        </Form.Item>
        {action === 'receive' && (
          <Form.Item name="should_merge_order" valuePropName="checked">
            <Checkbox checked={true}>{t('Merge Order With Same Patient')}</Checkbox>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default CreateReception;
